// extracted by mini-css-extract-plugin
export default {"search_result":"AddProfile_search_result__-zGMZ"};